import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    pagingServiceType,
    getServiceTypeById,
    saveOrUpdateServiceType,
    deleteServiceType
} from 'app/services/ServiceTypeService';

import { ServiceType } from "app/common/Model/ServiceType";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { PAGESIZE_ALL } from "app/common/LocalConst";

export default class ServiceTypeStore {
    listAllServiceType = [];
    searchServiceType = new SearchObject();
    pageServiceType = null;
    selectedServiceType = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteServiceType = false;
    recentlyUpdated = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllServiceType = () => {
        if (this.listAllServiceType?.length === 0 || this.recentlyUpdated) {
            pagingServiceType({ pageIndex: 1, pageSize: PAGESIZE_ALL })
                .then(({ data }) => {
                    this.listAllServiceType = data?.content || [];
                    this.recentlyUpdated = false;
                })
                .catch(error => {
                    console.error(error);
                    toast.error("Lấy loại dịch vụ có lỗi");
                })
        }
    }

    pagingServiceType = () => {
        pagingServiceType(this.searchServiceType).then(({ data }) => {
            this.pageServiceType = data;
        })
    }

    handleChangeFormSearch = (searchServiceType) => {
        this.searchServiceType = checkSearchObject(this.searchServiceType, searchServiceType);
        this.pagingServiceType();
    }

    handleOpenFormCreateOrEdit = (serviceTypeId) => {
        if (Boolean(serviceTypeId)) {
            getServiceTypeById(serviceTypeId).then(({ data }) => {
                this.selectedServiceType = data;
                this.openFormCreateOrEdit = true;
            }).catch(function (error) {
                toast.error("Lấy dữ liệu không thành công");
            });
        } else {
            this.selectedServiceType = new ServiceType();
            this.openFormCreateOrEdit = true;
        }
    }

    saveServiceType = async (serviceType, { setSubmitting }) => {
        return await saveOrUpdateServiceType(serviceType).then(() => {
            this.selectedServiceType = null;
            toast.success("Lưu loại dịch vụ thành công!");
            this.pagingServiceType();
            this.handleClosePopup();
            this.recentlyUpdated = true;
            this.listAllServiceType = [];
        }).catch(function (error) {
            toast.error("Lưu loại dịch vụ thất bại!");
        }).finally(function () {
            setSubmitting(false);
        });
    }

    handleDeleteServiceType = (serviceType) => {
        this.selectedServiceType = { id: serviceType?.id };
        this.openConfirmDeleteServiceType = true;
    }

    handleConfirmDeleteServiceType = () => deleteServiceType(this.selectedServiceType?.id)
        .then(() => {
            if (this.searchServiceType?.pageIndex > 1 && this.pageServiceType?.content?.length === 1) {
                this.searchServiceType.pageIndex -= 1;
            }
            toast.success("Xóa loại dịch vụ thành công!");
            this.pagingServiceType();
            this.recentlyUpdated = true;
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error("Xóa loại dịch vụ thất bại");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteServiceType = false;
    }

    resetStore = () => {
        this.searchServiceType = new SearchObject();
        this.pageServiceType = null;
        this.selectedServiceType = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteServiceType = false;
    }
}